import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useFormContext } from 'react-hook-form';
import { PropTypes } from 'prop-types';
import { Stack, Divider } from '@mui/material';
import SmsWidget from '../../../Components/SmsWidget';
import SMSFiltersWidget from './MessageFiltersWidget';
import { roundToHalfHour } from '../../../Helpers/dates';
import MassiveDatePicker from './Inputs/MassiveDatePicker';

const getDefaultScheduledOn = () => {
  const tomorrow = new Date(new Date());
  tomorrow.setDate(tomorrow.getDate() + 1);
  const { hours, minutes } = roundToHalfHour(tomorrow);
  tomorrow.setHours(hours);
  tomorrow.setMinutes(minutes);
  return tomorrow;
};

const MassiveSmsWrapper = function MassiveSmsWrapper({
  currentPage,
  templates = [],
  selectedFilters = null,
  customersInvolvedCounts = [],
  waveSections = [],
}) {
  const intl = useIntl();
  const { setValue } = useFormContext();

  const [selectedTemplate, setSelectedTemplate] = useState(0);

  const handleSelectTemplate = (event, newTemplate) => {
    if (newTemplate !== null && newTemplate !== selectedTemplate)
      setSelectedTemplate(newTemplate);
  };

  useEffect(() => {
    if (typeof selectedTemplate !== 'undefined' && selectedTemplate !== null)
      setValue(
        'templateId',
        selectedFilters?.isSMS
          ? templates[selectedTemplate]?.smsId
          : templates[selectedTemplate]?.emailId
      );
  }, [selectedTemplate, selectedFilters?.isSMS]);

  useEffect(() => {
    if (currentPage === 1) {
      const tomorrow = new Date(new Date());
      tomorrow.setDate(tomorrow.getDate() + 1);
      const { hours, minutes } = roundToHalfHour(tomorrow);
      tomorrow.setHours(hours);
      tomorrow.setMinutes(minutes);

      setSelectedTemplate(0);
    }
  }, [currentPage]);

  const formats = {
    normalDate: intl.messages.INPUT_DATE_FORMAT,
    keyboardDate: intl.messages.INPUT_DATE_FORMAT,
  };

  const tomorrow = new Date(new Date());
  tomorrow.setDate(tomorrow.getDate() + 1);
  return currentPage === 1 ? (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
      }}
    >
      <Stack
        sx={{
          flexDirection: "row",
          gap: "16px",
          alignItems: "center",
          p: "0px 24px"
        }}>
        <MassiveDatePicker
          name="scheduledOn"
          format={`${formats.normalDate} HH:mm`}
          label={intl.messages.SEND_DATETIME}
          defaultValue={getDefaultScheduledOn()}
          disablePast
          minDate={tomorrow}
          time
        />
        <MassiveDatePicker
          name="campaignEndsOn"
          label={intl.messages.CAMPAIGN_END_DATE}
          defaultValue={new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)} //30 days from today
          minDate={new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)}
        />
      </Stack>
      <Divider />
      <SmsWidget
        channel={selectedFilters?.isSMS ? 'SMS' : 'EMAIL'}
        templates={templates}
        selectedTemplate={selectedTemplate}
        handleChangeTemplate={handleSelectTemplate}
        customersInvolvedCounts={customersInvolvedCounts}
        massive
      />
    </div>
  ) : (
    <SMSFiltersWidget
      selectedFilters={selectedFilters}
      waveSections={waveSections}
    />
  );
};

MassiveSmsWrapper.propTypes = {
  templates: PropTypes.array,
  selectedFilters: PropTypes.object,
  currentPage: PropTypes.number.isRequired,
  customersInvolvedCounts: PropTypes.array,
  waveSections: PropTypes.array,
};

export default MassiveSmsWrapper;
